import { render, staticRenderFns } from "./searchSpeaker.vue?vue&type=template&id=0f54e118&"
import script from "./searchSpeaker.ts?vue&type=script&lang=ts&"
export * from "./searchSpeaker.ts?vue&type=script&lang=ts&"
import style0 from "./searchSpeaker.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports